module.exports = __webpack_public_path__ + "static/media/medalha-prata.77820593.png";